import { createContext, useContext } from 'react'
import { DEFAULT_MEASUREMENT_SYSTEM, type MeasurementSystem } from '@/shared/domain'

export type UnitsContextValue = {
  system: MeasurementSystem
  isMetric: boolean
  setSystem: (system: MeasurementSystem) => Promise<void>
}

export const UnitsContext = createContext<UnitsContextValue | null>(null)

const DEFAULT_UNITS: UnitsContextValue = {
  system: DEFAULT_MEASUREMENT_SYSTEM,
  isMetric: false,
  setSystem: () => Promise.resolve(),
}

export function useUnits(): UnitsContextValue {
  return useContext(UnitsContext) ?? DEFAULT_UNITS
}
